import React from 'react'
import Banner from '../home/banner/banner'
import Footer from '../footer/footer'
import { Tabs } from 'antd'

require('./caseshow.scss')
import { Get, wrapResponse } from './../../requst'

const TabPane = Tabs.TabPane;


export default class CaseShow extends React.Component {

    static async getInitialProps(ctx) {
        // let defaultActiveKey =this.props.location.satae?this.props.location.satae.key.toString():'0'
        let defaultActiveKey = ctx.query.key || '0'
        const [data, cateAndType, caseCenter, caseDetail] = await Promise.all([
            wrapResponse(Get({ url: 'case/banner' })),
            wrapResponse(Get({ url: 'case/cateAndType' })),
            wrapResponse(Get({ url: 'case/caseCenter', data: { cate_id: defaultActiveKey, page: 1, size: 1000 } })),
            wrapResponse(Get({ url: 'case/caseDetail' })),
        ])

        const footerProps = await Footer.getInitialProps()

        return { data, cateAndType, caseCenter: caseCenter.cases, caseDetail, footerProps, defaultActiveKey }
    }

    constructor(props, context) {
        super(props, context)
        this.callback = this.callback.bind(this);
        this.TAGcallback = this.TAGcallback.bind(this);
        this.state = {
            cateAndType: false,
            caseCenter: this.props.caseCenter,
            key: '',
        }

    }
    componentDidMount() {
        window.scroll(0, 0)

    }
    renderTab() {
        // (this.state.cateGoryAndTag.category)
        return this.props.cateAndType.category.map((item, index) => (
            <TabPane tab={item.title} key={item.id}>
            </TabPane>
        ))
    }
    renderTag() {
        return this.props.cateAndType.types.map((item, index) => (
            <TabPane tab={item.title} key={item.id}>
            </TabPane>
        ))
    }

    renderCaseCenter() {
        return this.state.caseCenter.map((item, index) => (
            <a style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} key={index} href={`/casedetails/${item.id}`}>
                <img className="Img" src={item.thumb} alt="" />
                <div className="TextBox">
                    <p>{item.title}</p>
                    {/*<p>小程序案例</p>*/}
                </div>
                <div className="Line"></div>
                <div className="Mask"></div>
            </a>
        ))
    }
    callback(key) {
        (key);
        this.setState({ key: key })
        this.Get({ url: 'case/caseCenter', data: { cate_id: key, page: 1, size: 1000 } }).then((res) => {
            ('案例中心', res.data.data.cases)
            this.setState({ caseCenter: res.data.data.cases })
        })
    }
    TAGcallback(tag) {
        ('key', tag)
        this.Get({ url: 'case/caseCenter', data: { cate_id: this.state.key, type_id: tag, page: 1, size: 1000 } }).then((res) => {
            ('案例中心', res.data.data.cases)
            this.setState({ caseCenter: res.data.data.cases })
        })
    }
    render() {
        // let defaultActiveKey =this.props.location.satae?this.props.location.satae.key.toString():'0'
        let defaultActiveKey = this.props.defaultActiveKey
        return (
            <div>
                <div style={{ width: '100%', height: '630px', display: 'flex', justifyContent: 'center' }}>
                    <img src={this.props.data ? this.props.data[0].photos : null} style={{ height: '100%' }} alt="" />
                </div>
                <div className="Case_Middle">
                    <div className="ContainerBox">
                        {this.props.cateAndType ? <Tabs defaultActiveKey={defaultActiveKey} onChange={this.callback}>
                            {this.renderTab()}
                        </Tabs> : null}
                        <div className="AAA">
                            {this.props.cateAndType ? <Tabs defaultActiveKey="0" onChange={this.TAGcallback}>
                                {this.renderTag()}
                            </Tabs> : null}
                        </div>
                        <ul className="Content">
                            {this.state.caseCenter ? this.renderCaseCenter() : null}

                        </ul>
                    </div>
                </div>
                <Footer {...this.props.footerProps} />
            </div>
        )
    }
}